/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} About_Section3_Li4Inputs */

const en_about_section3_li4 = /** @type {(inputs: About_Section3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Format Converters: Convert JSON to TypeScript, YAML, CSV, XML, and vice versa`)
};

const ko_about_section3_li4 = /** @type {(inputs: About_Section3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`형식 변환기: JSON을 TypeScript, YAML, CSV, XML로 변환 및 역변환`)
};

const ja_about_section3_li4 = /** @type {(inputs: About_Section3_Li4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`形式変換ツール: JSONをTypeScript、YAML、CSV、XMLに変換および逆変換`)
};

/**
* | output |
* | --- |
* | "Format Converters: Convert JSON to TypeScript, YAML, CSV, XML, and vice versa" |
*
* @param {About_Section3_Li4Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const about_section3_li4 = /** @type {((inputs?: About_Section3_Li4Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<About_Section3_Li4Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_about_section3_li4(inputs)
	if (locale === "ko") return ko_about_section3_li4(inputs)
	return ja_about_section3_li4(inputs)
});